import debounce from 'lodash/debounce'
import { DEFAULT_DEBOUNCE } from '../../lib/const'
import ClearableSearchInput from '../common/ClearableSearchInput.jsx'

const PhotographersDatabaseSearchBar = ({ onChange, term }) => {
  const handleOnCHange = debounce(
    (value) => onChange(value === '' ? null : value),
    DEFAULT_DEBOUNCE,
  )

  return (
    <div className="search-bar-div">
      <div>
        <form action="/search" className="photographers-search w-form">
          <input
            type="button"
            value="."
            className="photographers-search-button w-button"
            disabled
          />
          <ClearableSearchInput
            className="photographers-search-input w-input"
            maxLength="256"
            name="query"
            placeholder="Search by Name, Email, etc..."
            defaultValue={term}
            id="search"
            required=""
            onValueChange={handleOnCHange}
          />
        </form>
      </div>
    </div>
  )
}

export default PhotographersDatabaseSearchBar
